<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :headerMenuTogglerVisible="false"
    :headerConfig="headerConfig"
    :roamType="'screen'"
  >
    <gc-barcode-parser @barcodeScanned="barcodeScanned" />
    <template #headerContent>
      <!-- <GcHeaderContentStatic :title="'Sales Order 10101'" /> -->

      <GcRoamHeaderContentDynamic
        :title="'Roam Picking'"
        :baseView="baseView"
        :primaryLabel="primaryLabelFromStore"
        :secondaryLabel="secondaryLabelFromStore"
        :tertiaryLabel="tertiaryLabelFromStore"
        :isXSmall="isXSmall"
      />
    </template>
    <div v-for="item in viewPointTypes.headers" :key="item.value">
      <div
        v-if="selectedViewValue == item.value"
        class="view-card responsive-paddings"
      >
        <gc-form
          :formOptions="headerFormOptions"
          :formItems="formItems"
          :isNormal="true"
          :data-model="dataModel"
          :formMode="baseView.mode"
          :fromFrom="'roam-transaction'"
          ref="roam-transaction-header-form"
          :valueChangeCallBack="valueChangeCallBack"
          :checkValid="isValid"
          :validationGroup="'roam-transaction-header-form'"
          v-if="formItems"
        ></gc-form>
      </div>
    </div>

    <div v-for="item in viewPointTypes.details" :key="item.value" class="roam-gc-data-grid">
      <div v-if="selectedViewValue == item.value">
        <GcDataGrid
          :grouping="true"
          :export="true"
          :summary="true"
          :dataSourceConfig="screenJson.gridData.gridOptions.dataSource"
          :columns="screenJson.gridData.columns"
          :childGridColumns="screenJson.gridData.childColumns"
          :gridToolbar="screenJson.gridData.toolbar"
          :padColumn="true"
          :id="'roam-transaction-grid-' + item.value"
          :ref="'roamTransactionGrid-' + item.value"
          :isLocalDataSource="localDataGrid"
          :isEditableGrid="true"
          :showFooter="false"
          :gridOptions="screenJson.gridData.gridOptions"
          :rowClick="rowClickCallBack"
          :showSave="!saveDisabled.detail"
          :rowAlternationEnabled="false"
          :paging="false"
        />
      </div>
    </div>

    <div
      class="view-card responsive-paddings save-btn-area"
      v-if="
        getSelectedViewType == 'header'
          ? !saveDisabled.header
          : !saveDisabled.detail
      "
    >
      <DxButton
        :icon="saveRoamBtnConfig.icon"
        :text="saveRoamBtnConfig.text"
        type="default"
        width="100%"
        :disabled="
          getSelectedViewType == 'header'
            ? saveDisabled.header
            : saveDisabled.detail
        "
        @click="saveRoamTransaction"
      />
    </div>
    <GcPopup
      :popup-visible="detailPopUpFormVisible"
      :popup-title="detailPopUpConfig.option.title.text"
      :back-button-function="detailPopUpConfig.back.clickCallback"
      :fullScreen="true"
      :showTitle="detailPopUpConfig.option.title.visible"
      :saveButtonConfig="detailPopUpConfig.save"
      v-if="detailPopUpFormDataModel && detailPopUpFormVisible"
      :backButtonConfig="detailPopUpConfig.back"
    >
      <GcForm
        :formOptions="popUpFormOptions"
        :formItems="detailPopUpFormItems"
        :isNormal="true"
        :data-model="detailPopUpFormDataModel"
        :formMode="baseView.mode"
        v-if="detailPopUpFormItems"
        :formHeight="getFormHeight"
      ></GcForm>
    </GcPopup>

    <!-- <GcPopup
      :popup-visible="savePopupVisible"
      :popup-title="savePopupTitle"
      :back-button-function="savePopupBackButtonClick"
      :fullScreen="true"
      :showTitle="true"
      :saveButtonConfig="savePopupSaveButtonConfig"
      :backButtonConfig="{ text: 'Cancel' }"
      v-if="savePopupDataModel && savePopupVisible"
      ref="save-popup"
    >
      <GcForm
        :formOptions="popUpFormOptions"
        :formItems="saveFormPopupItems"
        :isNormal="true"
        :data-model="savePopupDataModel"
        :formMode="baseView.mode"
        v-if="saveFormPopupItems"
        ref="save-popup-form"
      ></GcForm>
    </GcPopup> -->

    <GcPopupRoamDespatchBatch
      v-if="batchPopUpData.visible"
      :popupVisible="batchPopUpData.visible"
      :popUpData="batchPopUpData"
      :key="new Date().getTime()"
    />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
export default {
  props: {
    barcodeScanned: {
      type: Function,
      default: () => {},
    },
    isXSmall: Boolean,
    isLarge: Boolean,
    // formsConfig: Object,
    backButtonRoute: {
      type: String,
      default: "/home",
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    screenJson: {
      type: Object,
      default: () => {},
    },
    formItems: {
      type: Array,
      default: () => {},
    },
    localDataGrid: {
      type: Boolean,
      default: false,
    },
    isLoaded: {
      type: Boolean,
      default: true,
    },
    setLoading: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Object,
      default: () => {},
    },
    saveConfigs: {
      type: Object,
    },
    rowClick: {
      type: Function,
      default: () => {},
    },
    validationSummary: {
      type: Array,
      default: () => [],
    },
    saveFormPopupItems: {
      type: Array,
      default: () => {},
    },
    selectedViewValue: {
      type: Number,
      default: 0,
    },
    headerConfig: {
      type: Object,
      default: () => {},
    },
    detailPopUpFormItems: {
      type: Array,
      default: () => {},
    },
    detailPopUpBack: {
      type: Function,
      default: () => {},
    },
    saveRoamTransaction: {
      type: Function,
      default: () => {},
    },
    detailPopUpFormVisible: {
      type: Boolean,
      default: false,
    },
    detailPopUpFormDataModel: {
      type: Object,
      default: () => {},
    },
    detailPopUpSaveCallBack: {
      type: Function,
      default: () => {},
    },
    getSelectedViewType: {
      type: String,
      default: "header",
    },

    detailPopUpConfig: {
      type: Object,
      default: undefined,
    },
    serverError: {
      type: Object,
      default: () => {},
    },
    saveRoamBtnConfig: {
      type: Object,
      default: () => {
        return {
          icon: "save",
          text: "SAVE",
        };
      },
    },
    backButtonFunctionOverwrite: {
      type: Function,
      default: undefined,
    },
    batchPopUpData: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
  },
  mixins: [RouteMixin, FormMixin],
  components: {},

  data() {
    return {
      isEditing: false,
      dataLoaded: false,
      headerFormOptions: {
        gcLabelLocation: "left",
      },
      isValid: false,
      // selectedViewValue: this.viewPointIndex,
      // formPopupVisible: false,
      formPopupTitle: "NONE",
      popUpFormOptions: {
        gcLabelLocation: "left",
      },
      formPopupItems: [],
      // formPopupDataModel: undefined,
      // saveButtonConfig: {
      //   text: "Update",
      //   clickCallback: () => {
      //     this.formPopupVisible = false;
      //   },
      // },
      rowClickEvent: undefined,
      popUpSaveDisabled: true,
      savePopupVisible: false,
      savePopupTitle: undefined,
      savePopupDataModel: undefined,
      savePopUpSaveDisabled: true,
      viewPointTypes: {
        headers: [],
        details: [],
      },
    };
  },
  beforeDestroy() {
    this.$store.dispatch("ui/setGridExpand", false);
  },
  computed: {
    getFormHeight() {
      return (
        window.innerHeight -
        120 -
        (this.detailPopUpConfig.option.title.visible ? 80 : 0)
      );
    },
    isDirty() {
      return this.isEditing;
    },
    ...mapGetters({
      primaryLabelFromStore: "transactionTemplate/getPrimaryLabel",
    }),
    ...mapGetters({
      secondaryLabelFromStore: "transactionTemplate/getSecondaryLabel",
    }),
    ...mapGetters({
      tertiaryLabelFromStore: "transactionTemplate/getTertiaryLabel",
    }),
    ...mapGetters({
      headerKey: "transactionTemplate/getHeaderKey",
    }),
  },
  async created() {
    if (this.headerConfig && this.headerConfig.options.viewPoints) {
      this.headerConfig.options.viewPoints.forEach((element) => {
        if (element.type == "header") this.viewPointTypes.headers.push(element);
        else if (element.type == "details")
          this.viewPointTypes.details.push(element);
      });
    }

    this.showLoading(this.setLoading);
  },
  methods: {
    valueChangeCallBack(isValid, brokenRules) {
      // eslint-disable-next-line no-console
      console.log("valueChangeCallBack ", isValid, brokenRules);
    },
    backButtonFunction() {
      // this.resetLabels();
      // if (!this.isDirty) this.setIgnoreRouteChangeConfirmation();
      if (this.backButtonFunctionOverwrite) this.backButtonFunctionOverwrite();
      else
        this.$router.push({
          path: this.backButtonRoute,
        });
    },
    rowClickCallBack(e) {
      if (
        !e.data ||
        (this.screenJson.gridData.gridOptions.options.rowSelect != undefined &&
          this.screenJson.gridData.gridOptions.options.rowSelect == false)
      )
        return;
      this.rowClickEvent = { ...e };
      this.rowClick(e);
    },
  },
  watch: {
    setLoading(val) {
      // console.log("********** ,", val);
      this.showLoading(val);
    },
    headerKey() {
      this.refreshView();
    },
    validationSummary: {
      handler(val) {
        if (val.length > 0) {
          this.displayValidationSummary(val);
        }
      },
      deep: true,
    },
    // saveDisabled: {
    //   handler(val) {
    //     if (val.line) {
    //       this.popUpSaveDisabled =
    //         this.formPopupDataModel && this.formPopupDataModel.EnableSave
    //           ? false
    //           : true;
    //       this.saveDisabled.line = false;
    //     }
    //     if (val.save) this.savePopUpSaveDisabled = false;
    //   },
    //   deep: true,
    // },
    // detailPopUpFormVisible(val) {
    //   // console.log("detailPopUpFormVisible ", val);
    //   if (val) {
    //     // this.formPopupVisible = true;
    //     // this.formPopupTitle = "NONE";
    //     this.formPopupItems = this.detailPopUpFormItems;
    //     // this.formPopupDataModel = this.detailPopUpFormDataModel;
    //     // this.detailPopUpDataCallBack(this.formPopupDataModel);
    //   }
    // },

    serverError: {
      handler(val) {
        this.displayServerError(val.err, val.msg);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.save-btn-area {
  position: absolute;
  bottom: 0;
  width: 100%;
  .dx-button-content {
    background-color: #03a9f4;
    .dx-button-text,
    .dx-icon::before {
      color: white !important;
    }
  }
}
</style>
